import { InputNumber, Slider } from "antd";
import { useEffect, useState } from "react";

import { SliderMarks } from "antd/es/slider";
import { CURRENCY } from "utils/textConstants";
import "./PriceItemFilter.scss";

const PriceItemFilter = ({
  minDefault,
  maxDefault,
  changePrice,
  minPrice,
  maxPrice,
}: any) => {
  const [min, setMin] = useState(minDefault);
  const [max, setMax] = useState(maxDefault);

  const [priceSlider, setPriceSlider] = useState([
    minPrice ? minPrice : minDefault,
    maxPrice ? maxPrice : maxDefault,
  ]);
  const [sliderMarks, setSliderMarks] = useState({});

  const handleSetMarks = (minPrice: number, maxPrice: number) => {
    const marks: SliderMarks = {};
    marks[minPrice] = `${minPrice} ${CURRENCY}`;
    marks[maxPrice] = `${maxPrice} ${CURRENCY}`;
    setSliderMarks(marks);
  };

  useEffect(() => {
    setPriceSlider([minPrice ?? minDefault, maxPrice ?? maxDefault]);
    handleSetMarks(minPrice ?? minDefault, maxPrice ?? maxDefault);
  }, [minPrice, maxPrice, minDefault, maxDefault]);

  //TODO kada se slug promeni rucno a ostane min_price ili max_price u url-u onda ne radi dobro slider
  // useEffect(() => {
  //   setMin(minDefault);
  //   setMax(maxDefault);
  //   if (minPrice == minDefault || maxPrice == maxDefault) {
  //     handleSetMarks(minDefault, maxDefault);
  //     setPriceSlider([minDefault, maxDefault]);
  //   }
  // }, [minDefault, maxDefault]);

  const handlePrice = (price: any) => {
    if (price[0] === minDefault && price[1] === maxDefault) {
      changePrice([null, null]);
    } else if (price[0] === minDefault) {
      changePrice([null, price[1]]);
    } else if (price[1] === maxDefault) {
      changePrice([price[0], null]);
    } else {
      changePrice(price);
    }
  };
  const onChangeSlider = (e: any) => {
    setPriceSlider(e);
  };
  const onSliderComplete = (e: any) => {
    handlePrice(e);
  };

  const handleInputChange = (minPrice: number, maxPrice: number) => {
    setPriceSlider([minPrice, maxPrice]);
    handlePrice([minPrice, maxPrice]);
    handleSetMarks(minPrice, maxPrice);
  };
  const onInputPriceLowerChange = (e: any) => {
    if (e.target.value >= minDefault && e.target.value <= maxDefault) {
      if (e.target.value <= priceSlider[1]) {
        handleInputChange(e.target.value, priceSlider[1]);
      } else {
        handleInputChange(priceSlider[1], e.target.value);
      }
    }
  };
  const onInputPriceHigherChange = (e: any) => {
    if (e.target.value >= minDefault && e.target.value <= maxDefault) {
      if (e.target.value >= priceSlider[0]) {
        handleInputChange(priceSlider[0], e.target.value);
      } else {
        handleInputChange(e.target.value, priceSlider[0]);
      }
    }
  };

  // const sliderRef = useRef<HTMLDivElement>(null);

  // useEffect(() => {
  //   const node = sliderRef.current;
  //   if (!node) return;
  //   // presretnemo wheel i sprečimo dalje slušanje
  //   const stop = (e: WheelEvent) => e.stopPropagation();
  //   node.addEventListener("wheel", stop, { passive: true });
  //   return () => {
  //     node.removeEventListener("wheel", stop);
  //   };
  // }, []);
  return (
    <div
      className="Price-Box"
      // ref={sliderRef}
    >
      <Slider
        range
        marks={sliderMarks}
        min={min}
        max={max}
        className="Price-Slider"
        defaultValue={[min, max]}
        value={[priceSlider[0], priceSlider[1]]}
        onChange={onChangeSlider}
        onChangeComplete={onSliderComplete}
      />
      {/* TODO ne radi gore dole dugme na input polju */}
      <div className="Price-Inputs">
        <div className="Price-Min">
          <label className="Price-Input-Label">Min</label>

          <InputNumber
            type="number"
            min={min}
            max={max}
            // defaultValue={min}
            className="Price-Input"
            value={priceSlider[0]}
            onKeyDown={onInputPriceLowerChange}
            onBlur={onInputPriceLowerChange}
            controls={false}
          />
        </div>
        <div className="Price-Max">
          <label className="Price-Input-Label">Max</label>
          <InputNumber
            type="number"
            min={min}
            max={max}
            className="Price-Input"
            // defaultValue={max}
            value={priceSlider[1]}
            onKeyDown={onInputPriceHigherChange}
            onBlur={onInputPriceHigherChange}
            controls={false}
          />
        </div>
      </div>
    </div>
  );
};
export default PriceItemFilter;
